export default __webpack_public_path__ + "static/media/cup.5abae383.png";